import styled from 'styled-components'
import { Card } from '@igs/react-styled-components'

export const ConfirmationCard = styled(Card)`
    grid-column: 1/-1;
    text-align: center;
`
